import { render, staticRenderFns } from "./MappingsReadOnly.vue?vue&type=template&id=722e7442"
import script from "./MappingsReadOnly.vue?vue&type=script&lang=js"
export * from "./MappingsReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports